import styled, { css } from 'styled-components';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../../../3rdPartyModules/_react-aria/utils/dist/mergeProps-CTIwukXV.js';

const Label = /*#__PURE__*/styled.label.withConfig({
  componentId: "sc-storm-ui-40026394__sc-o0l76a-0"
})(["cursor:pointer;text-align:center;vertical-align:middle;user-select:auto;@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms ease;}padding-left:0;padding-bottom:0;padding-right:0;padding-top:0;height:100%;width:100%;display:flex;flex:1;padding:0;border-radius:0;border:none;box-shadow:none;border-color:unset;outline:none;", ""], ({
  disabled
}) => disabled && css(["pointer-events:all;cursor:not-allowed;opacity:1;box-shadow:none;:hover{box-shadow:none;}"]));
const Input = /*#__PURE__*/styled.input.attrs(({
  focusProps,
  onBlur,
  onFocus
}) => $3ef42575df84b30b$export$9d1611c77c2fe928({
  onBlur,
  onFocus
}, focusProps)).withConfig({
  componentId: "sc-storm-ui-40026394__sc-o0l76a-1"
})(["appearance:none;border:none;margin:0;padding:0;display:inline;outline:0;opacity:0;width:0;height:0;"]);

export { Input as I, Label as L };
//# sourceMappingURL=TileToggleArea.styles-F9mKgRxE.js.map
